import { BaseObservableForm } from "apps-module/app/shared-library/forms/base-observable.form";
import { FormControl, FormGroup } from "@angular/forms";
import { nameof } from "apps-module/app/shared-library/utils/common.utils";
import _merge from "lodash/merge";
import { FormSearchParametersModel } from "apps-module/app/entry-modules/venues-search/models/form-search-parameters.model";

export class SearchForm extends BaseObservableForm<FormSearchParametersModel> {
    public static createForm(initialSearchParams: FormSearchParametersModel): SearchForm {
        const formGroup = new FormGroup({
            pageNumber: new FormControl<number>(initialSearchParams.pageNumber),
            pageId: new FormControl<number>(initialSearchParams.pageId),
            searchText: new FormControl<string>(initialSearchParams.searchText)
        });

        return new SearchForm(formGroup, initialSearchParams);
    }

    public get nativeForm(): FormGroup { return this.formInstance; }

    public get pageNumber(): FormControl<number> { return this.formInstance.get(nameof<FormSearchParametersModel>("pageNumber")) as FormControl<number>; }
    public get pageId(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("pageId")) as FormControl<string>; }
    public get searchText(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("searchText")) as FormControl<string>; }

    private constructor(
        formInstance: FormGroup,
        initialSearchParams: FormSearchParametersModel
    ) {
        super(formInstance, initialSearchParams);
    }

    public searchByPageNumber(): void {
        this.submit({
            searchText: this.initialFormState.searchText
        });
    }

    public searchByFilters(): void {
        this.submit({
            pageNumber: 1,
            searchText: this.initialFormState.searchText
        });
    }

    public searchByText(): void {
        this.submit({
            pageNumber: 1
        });
    }
}
